import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

export const importFileTypesExec: (keyof typeof UploadFileTypesEnum)[] = ['KNM', 'KNM_CORRECTION', 'CHECKLIST'];
